import { makeStyles } from '@mui/styles';
import Typography from 'apollo-react/components/Typography';
import React, { useMemo } from 'react';

import ItemDetail from './ItemDetail';
import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 5,
    marginBottom: 15,
  },
  sectionTitle: {
    width: 200,
    height: 24,
    fontSize: 16,
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: '#000',
    marginBottom: 17,
  },
});

const RecentItemsList = ({ items = [], navigateToItemEditor, itemTitle, itemQuantity }) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const title = translateString(itemTitle);
  const recentItems = useMemo(
    () =>
      items
        .sort((a, b) => new Date(b.modifiedDate).getTime() - new Date(a.modifiedDate).getTime())
        .slice(0, itemQuantity),
    [items, itemQuantity]
  );

  return (
    <>
      <Typography className={classes.sectionTitle}>{title}</Typography>
      <div className={classes.wrapper}>
        {recentItems.map((item) => (
          <ItemDetail key={item.id} item={item} navigateToItemEditor={navigateToItemEditor} />
        ))}
      </div>
    </>
  );
};

export default RecentItemsList;
